import type {ReportPageContent, ReportRunSet} from '../../store/thread';
import {agentPageContextChannel, type AgentPageContextReader} from '../channel';
import {runCountFiltered, runsFilter} from './workspace';

/** ReportInfo is the report's top-level identity, published as one value. */
type ReportInfo = Pick<ReportPageContent, 'title' | 'description'>;
/** ReportRunSetInfo is a run set's identity, published once per group. */
type ReportRunSetInfo = Pick<
  ReportRunSet,
  'name' | 'entityName' | 'projectName' | 'enabled'
>;

export const reportInfo = agentPageContextChannel<ReportInfo>();
export const reportRunSetInfo = agentPageContextChannel<ReportRunSetInfo>();

/**
 * reportReducer assembles a report's title, description, and run sets, one run
 * set per group, dropping run sets that carry no data. An empty report drops
 * via the collector's no-data check.
 */
export const reportReducer = (
  read: AgentPageContextReader
): Omit<ReportPageContent, 'type'> => {
  const runSets: ReportRunSet[] = read
    .groups()
    .map(group => ({
      ...group.one(reportRunSetInfo),
      runCountFiltered: group.one(runCountFiltered),
      runFiltersExpression: group.one(runsFilter),
    }))
    .filter(runSet => Object.values(runSet).some(value => value !== undefined));

  return {
    ...read.one(reportInfo),
    runSets: runSets.length > 0 ? runSets : undefined,
  };
};
